<template>
    <div class="wrapper-landing">
      <LandingHero
        title="Maak je gratis online geboortelijst aan"
        subtitle="Zet je favoriete kraamcadeaus op een rij en deel je persoonlijke lijst."
        origin="listabebe"
        lang="nl-NL"
        buttonText="Maak je lijst aan"
      >
        <template v-slot:cover>
          <source
            media="(max-width: 991px)"
            class=""
            srcset="../../assets/img/landings/cover-mujer-joven-embarazada-movil-resp.jpg"
            alt=""
            loading="lazy"
          />
          <img
            class="ln-hero__inset"
            src="../../assets/img/landings/cover-mujer-joven-embarazada-movil.jpg"
            alt=""
            loading="lazy"
          />
        </template>
      </LandingHero>
      <main class="bg-cercles">
        <LandingAppRatings />
  
        <section class="bb-container">
          <LandingFeaturesSimple title="Onze geboortelijst helpt je als:"
          :use-carousel="false"
          >
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-embarazada.svg" alt="" />
              </template>
              <template slot="title">
                Je net ouder bent geworden en niet precies weet wat je echt nodig hebt.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
              </template>
              <template slot="title">
                Familie en vrienden je steeds vragen wat jullie voor jullie baby wensen.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
              </template>
              <template slot="title"> Je artikelen uit verschillende winkels wilt kiezen. </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
              </template>
              <template slot="title">
                Je op zoek bent naar een eenvoudige en mooie manier om je wensen te delen.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
              </template>
              <template slot="title">
                Je alles graag strak georganiseerd hebt en geen enkel item wilt vergeten.
              </template>
            </LandingFeaturesSimpleItem>
          </LandingFeaturesSimple>
        </section>
      </main>
  
      <LandingFeaturesCover title="Een lijst vol mooie dingen">
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-retailers-box-int.webp" alt="" />
          </template>
          <template slot="titulo">
            Kies elk merk, elk model en elke winkel
          </template>

          <template slot="descripcion">
            <p>
              Plak de link van elke webshop in je lijst. Je hebt de volledige vrijheid om zelf te kiezen.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
          </template>
          <template slot="titulo"> Geld ontvangen voor je cadeaus, 100% gratis </template>

          <template slot="descripcion">
            <p>
              Je familie en vrienden kunnen je wensen vervullen of een bijdrage doen, zodat je deze zelf kunt aanschaffen. 100% gratis – voor jou en je dierbaren.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <FeaturesCoverItemListUpdate lang="nl-NL" />
      </LandingFeaturesCover>
  
      <main class="bg-cercles">
        <section class="bb-container">
          <LandingReviewsWedding lang="nl-NL" />
        </section>
      </main>
  
      <LandingComoCols title="Hoe werkt het?" subtitle="Jouw verlanglijst zonder grenzen">
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
          </template>
          <template slot="titulo">Kies precies wat jij wilt</template>
          <template slot="descripcion">
            <p>
              Kies een item uit elke gewenste webshop, plak de link in HelloBB en bewaar het op je lijst.
            </p>
            <p>
              Je kunt ook een spaarpot aanmaken om geld te verzamelen voor alles wat je wilt.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
          </template>
          <template slot="titulo">Deel je wensen</template>
          <template slot="descripcion">
            <p>Deel je lijst wanneer je maar wilt met vrienden en familie.</p>
            <p>
              Stuur ze een link zodat ze overal en zonder registratie toegang hebben tot jouw mooi gepersonaliseerde lijst.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
          </template>
          <template slot="titulo">Ontvang je cadeaus</template>
          <template slot="descripcion">
            <p>
              Je dierbaren kunnen een cadeau uit je lijst kiezen en het kopen.
              Ze kunnen het cadeau direct naar jou laten verzenden of bij henzelf laten bezorgen om het persoonlijk aan je te geven.
            </p>
            <p>
              Zodat je geen dubbele cadeaus krijgt, kunnen je vrienden en familie de items op je lijstje zelf als 'gekocht' afvinken.
            </p>
          </template>
        </LandingComoColsItem>
      </LandingComoCols>
  
      <LandingFooter lang="nl-NL" />
    </div>
  </template>
  
  <script>
  import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";
  
  import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
  import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";
  
  import LandingHero from "./components/LandingHero.vue";
  import LandingAppRatings from "./components/LandingAppRatings.vue";
  import LandingFeaturesCover from "./components/LandingFeaturesCover";
  import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
  import LandingReviews from "./components/LandingReviews.vue";
  import LandingHablan from "./components/LandingHablan.vue";
  import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
  import LandingFooter from "./components/LandingFooter.vue";
  
  import LandingComoCards from "./components/LandingComoCards.vue";
  import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
  import LandingComoColsItem from "./components/LandingComoColsItem.vue";
  import LandingComoCols from "./components/LandingComoCols.vue";

  import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";
  
  // import bbButton from "../../components/buttons/bbButton.vue";
  
  export default {
    name: "LandingNoListNL",
    metaInfo() {
      return {
        title: "HelloBB: de mooiste geboortelijst voor jouw gezin",
        htmlAttrs: {
          lang: "nl",
        },
        meta: [
          { name: "description", content: "HelloBB is de geboortelijst waarin al jouw wensen een plek hebben." },
          { name: "robots", content: "noindex" },
        ],
      };
    },
    components: {
      LandingComoCols,
      LandingComoColsItem,
      LandingAppRatings,
      LandingHablan,
      LandingReviews,
      LandingFooter,
      LandingHero,
      LandingFeaturesCover,
      LandingFeaturesCoverItem,
      LandingFeaturesSlider,
      LandingFeaturesSimple,
      LandingFeaturesSimpleItem,
      LandingComoCards,
      LandingComoCardsItem,
      LandingReviewsWedding,
      FeaturesCoverItemListUpdate,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
